<template>
  <div class="search">
    <div class="search-form mx-auto my-3">     
      <form @submit.prevent="handleSearch">
        <div class="input-group mb-3">
          <input type="text" 
            class="form-control" 
            placeholder="Leita..."
            autocomplete="off"
            v-focus
            v-model="filterObject.K"/>
          <div class="input-group-append">
            <button class="btn btn-outline-primary" type="submit">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="result-items row">
      <div v-for="res in results" :key="res.id" class="col-sm result-col border rounded">
        <div class="thumbnail result-item">
          <a @click="popUp(res)" v-b-modal.productDetail>
            <b-img-lazy :src="(res.images != null && res.images[2] != null) ? res.images[2] : res.image"
              width="200" 
              height="200" 
              blank-color="#bbb" 
              alt="Engin mynd" 
              class="border mx-auto d-block" />
            <span v-html="res.title"></span>
          </a>
        </div>
      </div>
    </div>
    <Loader :loading="loading" />
    
    <!-- Product Detail Modal Component -->
    <b-modal id="productDetail"
      title="Nánar um vöru" 
      size="lg" 
      @ok="openLink()" 
      cancel-title="Hætta við"
      v-bind='$props'
      @lazy="true"
      @centered=true
      ok-title="Kaupa">
      <Detail :product="product" />
    </b-modal>

    <!-- // NOTE: Hidden for now... -->
    <!-- <SearchFilter :searchFilter="this.filterObject" :providers="providers"/> -->
  </div>
</template>

<script>
import searchApi from '@/api/searchApi'
import productApi from '@/api/productApi'
import SearchFilter from '@/components/SearchFilter'
import Loader from '@/components/Loader'
import { mapGetters } from 'vuex'

export default {
  name: 'Search',
  data () {
    return {
      bottom: false,
      noMoreResults: false,
      results: [],
      product: {},
      filterObject: {
        P: [1, 2, 3],
        // P: 3,
        OF: 'Price',
        OD: 'Descending',
        S: 20,
        N: 1,
        M: 1000,
        C: 10,
        R: 'Asia',
        K: '',
        D: false,
        X: 3000
      }
    }
  },
  components: {
    'SearchFilter': SearchFilter,
    'Loader': Loader
  },
  created () {
    this.$store.dispatch('getProviders')
    // this.$store.dispatch('getCurrencies')
    this.$store.dispatch('isLoading')
    window.addEventListener('scroll', () => {
      this.bottom = this.bottomVisible()
    })
  },
  computed: {
    // ...mapState(['loading']),
    ...mapGetters(['providers', 'currencies', 'loading'])
  },
  watch: {
    bottom (bottom) {
      if (bottom) {
        this.addToResults()
      }
    }
  },
  methods: {
    setLoading: function (isLoading) {
      this.$store.dispatch('isLoading', isLoading)
    },
    handleSearch: function () {
      this.results = []
      // TODO: loop through results and convert to numbers
      // this.filterObject.SearchProviders = [1, 2, 3, 4]
      this.setLoading(true)
      searchApi.search(this.filterObject)
        .then(response => {
          this.setLoading(false)
          this.results = response.data
        }).catch(function (err) {
          console.error('error', err)
          this.setLoading(false)
        })
    },
    openLink: function () {
      window.open(this.product.url, '_blank')
    },
    popUp: function (product) {
      this.product = product
      this.product.loading = true
      productApi.getProduct(product.id, product.providerId).then((response) => {
        this.product = response.data
        this.product.loading = false
      })
    },
    bottomVisible: function () {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      return bottomOfPage || pageHeight < visible
    },
    addToResults: function () {
      this.setLoading(true)
      this.filterObject.N += 1
      searchApi.search(this.filterObject)
        .then(response => {
          this.setLoading(false)
          if (response.data.length === 0) {
            this.noMoreResults = true
          }
          this.results.push(...response.data)
          setTimeout(() => {
            if (this.bottomVisible() && !this.noMoreResults) {
              this.addToResults()
            }
          }, 1000)
        }).catch(function (err) {
          console.error('error', err)
          this.setLoading(false)
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.search-form {
  max-width: 400px;
}
.result-col {
  padding: 5px;
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue